<template>
  <MyModal
    title="测风塔选址"
    width="454px"
    height="auto"
    :style="{ top: '95px', left: '425px' }"
    @closeClick="handleCloseModalClick"
  >
    <div class="my-content">
      <!--      <div class="adjust-desc-new">-->
      <!--        鼠标选中可以进行风机调整-->
      <!--      </div>-->

      <div class="deploy-content">
        <div class="row">
          <div
            :class="['row-item']"
            v-for="(item, index) in rowItemList"
            :key="index"
          >
            <div class="row-item-core">
              <div class="key">{{ item.label }}</div>
              <div class="value">
                <StandInput
                  v-model="item.value"
                  :myType="item.type"
                  :onlyNumber="item.onlyNumber"
                  :unit="item.unit"
                  :interger="item.interger"
                  :max="item.max"
                  :min="item.min"
                  :selectOptions="item.selectOptions"
                ></StandInput>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="row-item">
            <div class="row-item-core">
              <div class="key">高级设置</div>
              <div class="value">
                <div class="stand-switch-core">
                  <el-switch v-model="advanced" active-color="#6290F7">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="row" v-if="advanced">
          <div
            :class="['row-item']"
            v-for="(item, index) in seniorItemList"
            v-show="item.landform === 1"
            :key="index"
          >
            <div class="row-item-core">
              <div class="key">{{ item.label }}</div>
              <div class="value">
                <StandInput
                  v-model="item.value"
                  :myType="item.type"
                  :onlyNumber="item.onlyNumber"
                  :unit="item.unit"
                  :interger="item.interger"
                ></StandInput>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="deploy-btn-wrapper" style="justify-content: center">
        <ct-button size="small" type="primary" :btnClick="handleDeployClick">开始选址</ct-button>
      </div>

      <div style="border-top:1px solid #DCDFE6;padding:10px 0;display: flex;">
        <div style="padding-right:25px;">
          测风塔总数： {{ towerList.length }}
          <i class="el-icon-add-location i-con" @click="handleAddFengji(true)"
             v-if="!toolUIStatus.fengji">增加</i>

          <template v-else>
            <i class="el-icon-check i-con" @click="handleSaceFengjiClick">保存</i>
            <i class="el-icon-close i-con" @click="cancelCreateFengji(false)">取消</i>
          </template>
        </div>
      </div>

      <template v-if="towerList.length">
        <el-table
          :data="towerList"
          style="width: 100%"
          max-height="250px"
          row-class-name="table-row-class-name"
          size="mini"
          @row-click="rowClick"
        >
          <el-table-column prop="towerNo" label="编号" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="lon" label="经度" header-align="center" align="center" width="75">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.inputLonName"
                v-if="scope.row.edit"
              />
              <span v-else>{{ scope.row.lon }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lat" label="纬度" header-align="center" align="center" width="75">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.inputLatName"
                v-if="scope.row.edit"
              />

              <span v-else>{{ scope.row.lat }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="equipmentType" label="设备　模式" header-align="center" align="center" width="48">
            <template slot-scope="scope">
              <el-select v-if="scope.row.edit" v-model="scope.row.equipmentTypeName" placeholder="请选择类别">
                <el-option label="测风塔" :value="1"></el-option>
                <el-option label="雷达" :value="2"></el-option>
              </el-select>
              <span v-else>
                {{scope.row.equipmentType == 1 ? '测风塔':'雷达'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="height" label="高度" header-align="center" align="center" width="40">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.inputHeightName"
                v-if="scope.row.edit"
              />

              <span v-else>{{ scope.row.height }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="surfaceType" label="地表　情况" header-align="center" align="center" width="48">
            <template slot-scope="scope">
              <el-select v-if="scope.row.edit" v-model="scope.row.surfaceTypeName" placeholder="请选择类别">
                <el-option label="无森林" :value="1"></el-option>
                <el-option label="有森林" :value="2"></el-option>
              </el-select>
              <span v-else>
                {{scope.row.surfaceType == 1 ? '无森林':'有森林'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="64">
            <template slot-scope="scope">
              <template v-if="!scope.row.edit">
                <el-button
                  @click="scope.row.edit = true"
                  type="text"
                  size="small"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="deleteTowerItem(scope.row)"
                  >删除</el-button
                >
              </template>
              <template v-if="scope.row.edit">
                <el-button
                  type="text"
                  size="small"
                  @click="updateTowerItem(scope.row)"
                  >确定</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="scope.row.edit = false"
                  >取消</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="deploy-btn-row deploy-btn-wrapper"
          style="padding-top:10px;"
        >
          <div>
<!--            测风塔总数： {{ towerList.length }}-->
<!--            <ct-button-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              :btnClick="() => handleAddFengji(true)"-->
<!--              v-if="!toolUIStatus.fengji"-->
<!--              >增加</ct-button-->
<!--            >-->

<!--            <template v-else>-->
<!--              <ct-button size="small" :btnClick="handleSaceFengjiClick" type="primary"-->
<!--                >保存</ct-button-->
<!--              >-->
<!--              <ct-button-->
<!--                size="small"-->
<!--                :btnClick="-->
<!--                  () => {-->
<!--                    cancelCreateFengji(false);-->
<!--                  }-->
<!--                "-->
<!--                >取消</ct-button-->
<!--              >-->
<!--            </template>-->
          </div>
          <div>
          <ct-button size="small" type="primary" :btnClick="handleExportTower">导出测风塔</ct-button>
          <ct-button size="small" type="primary" :btnClick="handleGenerateTower">生成选址报告</ct-button>
          </div>
          </div>
      </template>
    </div>
  </MyModal>
</template>

<script>
import MyModal from './modal';
import StandInput from './stand-input';
import { hasPermission } from '@/permission/index';
// import {
//   toFixed,
//   parseMapDataToGeoInfo,
//   booleanPointInPolygon
// } from '../utils';
// import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils';
import { mapGetters } from 'vuex';
import { updateTower } from '../service';
import L from 'leaflet';
import towerIcon from '@/asset/windfarm/tower.png';

export default {
  components: {
    MyModal,
    StandInput,
  },
  computed: {
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'exclusiveList',
      'boosterList',
      'specificDragFlag',
      'projectList',
    ]),
  },
  data() {
    return {
      isExportTurbine: false,
      isBootEdit: false,
      advanced: true,
      showImportWindFarmDialog: false,
      towerList: [],
      manualFengjiList: [],
      rowItemList: [
        {
          label: '测风塔数量',
          key: 'count',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'input',
          unit: '座',
        },
        {
          label: '选址方式',
          key: 'layoutType',
          value: null,
          type: 'select',
          selectOptions: [
            { label: '山地', value: 1 },
            { label: '平原', value: 2 },
          ],
        },
        {
          label: '代表范围半径',
          key: 'typicalRadius',
          value: null,
          interger: true,
          landform: 2,
          unit: 'm',
          onlyNumber: true,
          min: 200,
          type: 'input',
        },
        {
          label: '代表范围重叠度',
          key: 'intersection',
          value: null,
          unit: 'R',
          onlyNumber: true,
          interger: false,
          max: 1,
          landform: 2,
          type: 'input',
        },
        {
          label: '最大代表高差',
          key: 'typicalAltitudeRange',
          value: null,
          unit: 'm',
          onlyNumber: true,
          interger: true,
          landform: 2,
          type: 'input',
        },
        /*{
          label: '最大限制坡度',
          key: 'inflowAngle',
          value: null,
          unit: '%',
          onlyNumber: true,
          interger: true,
          landform: 2,
          type: 'input',
        },
        {
          label: '塔体高度',
          key: 'towerHeight',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'input',
          unit: 'm',
        },*/
        {
          label: '拉线高差',
          key: 'lineAltitudeLimit',
          value: null,
          unit: 'm',
          onlyNumber: true,
          interger: true,
          landform: 2,
          type: 'input',
        },
        // {
        //   label: '边界距离',
        //   key: 'distance',
        //   value: null,
        //   unit: 'm',
        //   onlyNumber: true,
        //   interger: true,
        //   landform: 1,
        //   type: 'input',
        // },

      ],
      seniorItemList: [],
      limitList: [],
      turbineTypeList: [],
      autoTurbineParam: {
        maxSlope: null,
        turbineCount: null,
        maxAltitude: null,
        turbineType: null,
        turbineTypeId: null,
        turbineHeight: null,
        turbineDistance: null,
      },
      manualTypeList: [],
      manualTurbineParam: {
        turbineTypeId: null,
        turbineHeight: null,
      },
      store: null,
      tableData: [],
      adding: false,
    };
  },
  created() {
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
    this.$bus.$on('createfengji', this.createfengji);
    this.$bus.$on('updateTowerLocation', this.updateTowerLocation);

    setTimeout(() => {
      if (this.hasPerms('layer-landWspd')) {
        this.$bus.$emit('checkLayer', ['fengziyuan']);
      }
      this.$bus.$emit('checkLayer', 'tiandi');
      this.$bus.$emit('getCluster', false);
    });
  },
  beforeDestroy() {
    this.$store.commit('WindFarm/SET_specificDragFlag', false);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
    // this.handleCancelFjResult();
    this.cancelCreateFengji(false);
    this.$bus.$off('createfengji', this.createfengji);
    this.$bus.$off('updateTowerLocation', this.updateTowerLocation);
  },
  mounted() {
    this.queryAutoParams();
  },
  methods: {
    hasPerms(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms);
    },
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 1);
    },
    handleDeployClick() {
      const params = this.rowItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});
      const seniorParams = this.seniorItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});

      this.$postForm('/windfarm/station/recommendTower', {
        data: {
          ...params,
          ...seniorParams,
          //inflowangle: params.inflowAngle,
          planId: this.$route.query.planId,
          projectId: this.$route.query.projectId || '0',
          distance: this.autoTurbineParam.distance
        },
        showError: true,
        showSuccess: true,
        showLoading: {
          mask: true,
          loadingContent:
            '测风塔选址在考虑测风塔代表半径及地形条件限制基础上给出给定数量的测风塔位置',
        },
      }).then(() => {
        this.$bus.$emit('updateTowerList');
        this.$bus.$emit('updatePlanToolIconStatus');
        this.getTowerList();
        // 更新towerList
        // this.$store.dispatch('WindFarm/getTowerList', {
        //   params: {
        //     planId: this.$route.query.planId,
        //   },
        // });
      });
    },
    getTowerList() {
      this.$fetch('/windfarm/station/getRecommendTowerList', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data } = res;
        const { towerList } = data;
        if (towerList) {
          this.towerList = towerList.map((v) => {
            return {
              inputLatName: v.lat,
              inputHeightName: v.height,
              edit: false,
              inputLonName: v.lon,
              ...v,
              isShow: true,
              equipmentTypeName: v.equipmentType,
              surfaceTypeName: v.surfaceType,
            };
          });
          this.$bus.$emit('showTowersCircle',data);
        }
      });
    },
    queryAutoParams() {
      this.$fetch('/windfarm/station/getRecommendTowerList', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data } = res;
        const { towerList, param } = data;
        if (towerList) {
          this.towerList = towerList.map((v) => {
            return {
              inputLatName: v.lat,
              inputHeightName: v.height,
              edit: false,
              inputLonName: v.lon,
              ...v,
              isShow: true,
              equipmentTypeName: v.equipmentType,
              surfaceTypeName: v.surfaceType
            };
          });
          this.$store.commit('WindFarm/SET_TOWERLIST', this.towerList);
          this.$store.commit('WindFarm/UPDATE_TOWER_AREA');
        }

        this.autoTurbineParam = param[0];
        this.rowItemList.forEach((item) => {
          item.value = this.autoTurbineParam[item.key];
        });
        this.seniorItemList.forEach((item) => {
          item.value = this.autoTurbineParam[item.key];
          if (item.key === 'distance') {
            item.landform = 1;
          } else {
            item.landform = this.autoTurbineParam['landform'];
          }
        });

        // const selectTypeItem = this.rowItemList.find(
        //   i => i.label === '风机类型'
        // );
        // this.$set(selectTypeItem, 'selectOptions', this.turbineTypeList);
      });
    },
    handleSaceFengjiClick() {
      if (!this.manualFengjiList.length) {
        return this.$message.warning('请添加测风塔');
      }
      const lat = this.manualFengjiList.map(i => i.data.lat).join(',');
      const lon = this.manualFengjiList.map(i => i.data.lon).join(',');
      this.$postForm('/windfarm/station/addRecommendTowerByPlanId', {
        data: {
          planId: this.$route.query.planId,
          lat,
          lon,
        },
        showSuccess: true,
        showError: true,
        showLoading: true,
      }).then(() => {
        this.$bus.$emit('updateTowerList');

        this.getTowerList();

        this.manualFengjiList = [];

        this.handleAddFengji(false);
      });
    },
    cancelCreateFengji(value) {
      this.$bus.$emit('updateTowerList');
      this.handleAddFengji(value);
      this.manualFengjiList = [];
    },
    handleCancelFjResult() {
      this.$nextTick(() => {
        this.$bus.$emit('resultClickFj');
      });
    },
    createfengji(data) {
      const { lat, lng: lon } = data;

      this.manualFengjiList.push({
        data: {
          lat,
          lon,
        },
      });
    },
    handleAddFengji(value) {
      if (value) {
        this.handleCancelFjResult();
      } else {
        this.$nextTick(() => {
          this.$bus.$emit('resultClickFj');
        });
      }

      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['fengji'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'fengji',
        value: !status,
      });

      this.$bus.$emit('getMapInstance', (map) => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: towerIcon,
            iconSize: [25, 25],
            iconAnchor: [13, 25],
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status,
      });
    },
    updateTowerItem(tower) {
      updateTower({
        lat: tower.inputLatName,
        height: tower.inputHeightName,
        lon: tower.inputLonName,
        equipmentType: tower.equipmentTypeName,
        surfaceType: tower.surfaceTypeName,
        towerId: tower.towerId,
      }).then(() => {
        this.getTowerList();
        this.$bus.$emit('updateTowerList');
      });
    },
    deleteTowerItem(item) {
      this.$confirm('是否删除测风塔', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$postForm('/windfarm/station/deleteRecommendTower', {
          showSuccess: true,
          showError: true,
          data: {
            towerId: item.towerId,
          },
        }).then(() => {
          this.getTowerList();
          this.$bus.$emit('updateTowerList');
        });
      });
    },
    handleExportTower(){
      if(this.isExportTurbine){
        return false;
      }
      this.isExportTurbine = true;
      const apiKey = getToken();
      // const loading = this.$loading({
      //   text: '正在导出测风塔，请稍后...',
      //   spinner: 'el-icon-loading',
      // });

      this.$fetch(`/windfarm/station/exportRecommendTowerList?apiKey=${apiKey}&planId=${this.$route.query.planId}`, {
        method: 'post',
        showError: true,
        // showLoading: {
        //   mask: true,
        //   loadingContent: '正在下载请稍后'
        // },
        noJudge: true,
        responseType: 'blob',
      })
        .then(res => {
          if(res.status == 401){
            this.errorMessage(res.data);
            return;
          }
          const blob = new Blob([res.data]);
          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);
          link.target = '_blank';
          link.href = fileURL;
          link.download = '测风塔列表.csv'; //文件名称
          link.click();
          // loading.close();
          this.isExportTurbine = false;
        })
        .catch(() => {});
    },
    async errorMessage(data){
      const text = await data.text(); // 将 Blob 转为文本
      this.$message.error(text);
    },
    handleGenerateTower(){
      const apiKey = getToken();
      const loading = this.$loading({
        text: '正在导出报告，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      });
      //apiKey=${apiKey}&planId=${this.$route.query.planId}
      this.$fetch(`/windfarm/report/towerReport?apiKey=${apiKey}&planId=${this.$route.query.planId}&projectId=${this.$route.query.projectId}`, {
        method: 'post',
        showError: true,
        noJudge: true,
        responseType: 'blob',
      })
        .then(res => {
          if(res.status == 401){
            loading.close();
            this.errorMessage(res.data);
            return;
          }
          const blob = new Blob([res.data]);
          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);
          link.target = '_blank';
          link.href = fileURL;
          let docName = this.$route.query.projectName + "-测风塔选址报告.docx";
          link.download = docName; //文件名称
          link.click();
          loading.close();

        })
        .catch(() => {});
    },
    async errorMessage(data){
      const text = await data.text(); // 将 Blob 转为文本
      this.$message.error(text);
    },
    rowClick(row){
      row.id = row.towerId;
      this.$bus.$emit('showTowerDetail',row,row.edit);
    },
    updateTowerLocation(tower){
      this.towerList = this.towerList.map((v) => {
        if(v.towerId == tower.id){
            v.inputLatName = tower.lat;
            v.inputHeightName = tower.height;
            v.lat = tower.lat;
            v.edit = true;
            v.inputLonName = tower.lng;
            v.lon = tower.lng;
            v.isShow =  true;
          v.equipmentTypeName= tower.equipmentType;
          v.surfaceTypeName= tower.surfaceType
        }
        return v;
      });
    }
  },
};
</script>

<style lang="less" scoped>
::v-deep.wind-farm-modal-wrapper .content{
  overflow-y: auto;
}
.i-con{
  color:#1890ff;
  font-size: 14px;
  padding:0 0 0 8px;
  cursor: pointer;
}
.adjust-desc-click {
  position: absolute;
  width: 320px;
  margin-right: 120px;
  margin-top: 8px;
  font-weight: 800;
  color: #ff8b24;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mr-10 {
  margin-right: 5px;
}
.width-40 {
  font-size: 12px;
  height: 100%;
  width: 60px;
}
.my-btn-warpper {
  display: flex;
  padding: 15px 10px;
  text-align: right;
  flex-direction: row-reverse;

  .ct-btn:last-child {
    margin-right: 10px;
  }
}
.upload-demo {
  height: 28px;
  .click-area {
    .file-name {
      width: 300px;
      height: 28px;
      border-radius: 7px;
      padding-left: 10px;
      text-align: left;
      margin-right: 20px;
      background-color: #fff;
      border: 2px solid #d9e6f3;
    }
    display: flex;
    justify-content: space-between;
  }
}
.my-content {
  padding: 10px 0 0 0;
  .adjust-desc-new {
    margin-top: 10px;
    font-weight: 800;
    color: #ff8b24;
    font-size: 14px;
    line-height: 20px;
  }
  .core {
    justify-content: space-between;
    // background-color: #fff;
    border-radius: 7px;
    display: flex;
    // padding: 10px;
    .tab {
      //user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }
  .deploy-content {
    padding: 0 10px;
    color: @black-color;
  }
  .row {
    .row-item {
      display: inline-block;
      //padding-left: 10px;
      width: 190px;
      margin-bottom: 5px;
      &.place {
        width: 100%;
        &:nth-child(2n) {
          margin-left: 10px;
        }
        &:nth-child(2n + 1) {
          margin-right: 10px;
        }
        .row-item-core {
          display: flex;
          align-items: center;
          .key {
            margin-right: 1px;
            width: 88px;
            font-size: 13px;
            font-weight: 400;
          }
          .value {
            width: 280px;
            font-size: 13px;
          }
        }
      }
      &:nth-child(2n + 1) {
        margin-left: 0px;
      }
      &:nth-child(2n) {
        margin-left: 10px;
      }
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          margin-right: 5px;
          min-width: 90px;
          padding-left: 5px;
          font-weight: 400;
          font-size: 12px;
        }
        .value {
          min-width: 95px;
          font-size: 12px;
        }
      }
    }
  }

  .adjust-area {
    margin-top: 10px;
    text-align: right;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .manual-row {
    margin-bottom: 10px;
    display: flex;
    align-content: center;
    .key {
      margin-right: 5px;
      width: 60px;
      line-height: 30px;
      font-size: 13px;
      font-weight: 400;
    }
    .value {
      width: 220px;
    }
    .el-btn-wrapper {
      margin-left: 10px;
    }
  }

  .deploy-btn-row {
    display: flex;
    justify-content: space-between;
    color: @black-color;
  }
  .deploy-btn-wrapper {
    text-align: center;
    display: flex;
    align-items: center;
    margin: 5px 0 10px 0;
  }
  .add-fengji-wrapper {
    text-align: right;
    margin-top: 10px;
  }

  .add-fengji {
    display: inline-block;
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
    font-weight: normal;
    font-size: 16px;
    color: #000;
    position: relative;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .adjust-desc {
    position: relative;
    left: -15px;
    font-size: 14px;
    font-weight: bold;
  }

  .limit-area,
  .shengyazhan-area {
    margin-top: 10px;
    .my-title {
      font-weight: normal;
      font-size: 16px;
      color: #000;
      padding: 0px 10px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0px;
        top: 1px;
        border-radius: 3px;
        width: 5px;
        height: 100%;
        background-color: #015aac;
      }
      i {
        cursor: pointer;
        &:hover {
          color: #478beb;
        }
        &.is-active {
          color: #0159ac;
        }
      }
    }
    .area-content {
      margin-top: 10px;
      padding: 0px 10px;
      max-height: 120px;
      overflow: auto;
    }
    .depoly-content-item {
      .el-tag {
        color: #537dfc;
        background: rgba(83, 125, 252, 0.2);
        border: 1px solid #537dfc;
        box-sizing: border-box;
        border-radius: 2px;
      }
      &:nth-child(n + 1) {
        margin-top: 5px;
      }
      display: flex;
      align-items: center;
      position: relative;
      & > span {
        display: flex;
        align-items: center;
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0;
        i {
          display: flex;
          align-items: center;
          cursor: pointer;

          &.is-active {
            color: #3cc2e6;
          }
          &:hover {
            color: #478beb;
          }
          &:nth-child(n + 2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
/deep/ .el-table .cell{
  padding-left: 3px;
  padding-right: 3px;
}
/deep/ .el-table th.el-table__cell>.cell{
  padding-left: 5px;
  padding-right: 5px;
  line-height: 28px;
}
/deep/ .el-table--mini .el-table__cell{
  padding: 2px 0;
}
/deep/ .el-table .el-input__inner{
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  padding: 0 2px;
}
/deep/ .el-button--text{
  padding-left: 1px;
  padding-right: 1px;
}

</style>
